import axios from "axios";
import { TabIFRFForm } from "../pages/ifrf/TabIFRF";
import { Catalogos } from "./Catalogos";

export class IFRFService {

    public async consultaIfrf(form:TabIFRFForm) {

        let cuboIfrf:string = form.rutaTematica ; // Tipo: Indicadores de Flujos de Recaudacion Fiscal

        let dimsVal:string='';
        let metricasVal:string='';
        
        if( form.rutaTematica === '' ) {
            throw new Error( 'Selecciona la ruta tematica.' );
        } else {
            if( form.rutaTematica === 'CIFRF_RFG' ) {
                Catalogos.CAT_VARIABLES_IFRF.json.forEach( (item,i) => {
                    if ( Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                        dimsVal+=item.Id;
                        dimsVal+=',';
                    }
                })
                if( dimsVal === '' ) {
                    throw new Error( 'Selecciona de 1 a 3 variables.' );
                }
                //metricasVal='R5_04,R5_04_02_01';
            } else if( form.rutaTematica === 'CIFRF_RFE' ) {
                dimsVal+=form.edad;
                if( dimsVal === '' ) {
                    throw new Error( 'Selecciona una variable.' );
                }
                //metricasVal='R5_03';
            } else if( form.rutaTematica === 'CIFRF_RFNI' ) {
                dimsVal+=form.nivelIngreso;
                if( dimsVal === '' ) {
                    throw new Error( 'Selecciona una variable.' );
                }
                //metricasVal='R5_03';
            }
        }

        Catalogos.CAT_METRICAS_IFRF.json.forEach( (item,i) => {
            if ( Object.getOwnPropertyDescriptor(form, item.Id ) !== undefined && Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                metricasVal+=item.Id;
                metricasVal+=',';
            }
        })

        /*
        if( form.rutaTematicaBimestre === '' ) {
            throw new Error( 'Selecciona el bimestre.' );
        }*/

        /*
        if( form.fechaInicio.valueOf() < Catalogos.MIN_DATE.valueOf() || form.fechaFin.valueOf() < Catalogos.MIN_DATE.valueOf() ) {
            throw new Error( 'Selecciona el periodo.' );
        } else if( form.fechaInicio.valueOf() > form.fechaFin.valueOf() ) {
            throw new Error( 'La Fecha fin debé ser posterior a la Fecha inicio.' );
        }
        */
        /*if( form.fechaRango.split( ' al ' ).length < 2 ) {
            throw new Error( 'Selecciona el periodo.' );
        }
        */
        if( form.bimIni === '' || form.bimFin === '' ) {
            throw new Error( 'Selecciona el periodo.' );
        } else {
            if ( parseInt( form.yearIni ) > parseInt( form.yearFin ) ) {
                throw new Error( 'El bimestre final debé ser mayor o igual a bimestre inicial.' );
            } else {
                if ( parseInt( form.yearIni ) === parseInt( form.yearFin ) ) {
                    if ( parseInt( form.bimIni ) > parseInt( form.bimFin ) ) {
                        throw new Error( 'El bimestre final debé ser mayor o igual a bimestre inicial.' );
                    }
                }
            }
        }

        if( metricasVal === '' ) {
            throw new Error( 'Selecciona las metricas.' );
        }

        const data = await axios.get(
                process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?' +
                    'dims=dimsVal&mtrs=mtrsVal&per=perVal&bim=bimVal&tipo=tipoVal'
                    .replaceAll( 'dimsVal', dimsVal )
                    .replaceAll( 'mtrsVal', metricasVal )
                    //.replaceAll( 'perVal', 'pai,pmi,paf,pmf'.replaceAll( 'pai', form.fechaInicio.getFullYear()+'' ).replaceAll( 'pmi', ( form.fechaInicio.getMonth() + 1 ) + '' ).replaceAll( 'paf' , ( form.fechaFin ? form.fechaFin.getFullYear() : form.fechaInicio.getFullYear() ) + '' ).replaceAll( 'pmf', (  ( form.fechaFin ? form.fechaFin.getMonth() : form.fechaInicio.getMonth() )+ 1 ) + '' ) )
                    .replaceAll( 'perVal', 'pai,pmi,paf,pmf'.replaceAll( 'pai', form.yearIni ).replaceAll( 'pmi', form.bimIni ).replaceAll( 'paf' , form.yearFin ).replaceAll( 'pmf', form.bimFin ) )
                    .replaceAll( 'bimVal', form.rutaTematicaBimestre )
                    .replaceAll( 'tipoVal', cuboIfrf )
                , {
                    responseType: 'blob',
                }
            ).then((res) => {
                return res.data;
            });

        return data;
    }
}